/**
 * El checkbox "Avisarle al equipo en qué pantalla estabas", con el detalle desplegable.
 *
 * La lista se renderiza DESDE EL OBJETO REAL que se va a enviar, no desde un texto escrito a mano:
 * así la explicación no puede desincronizarse de los datos y prometer algo distinto de lo que
 * viaja.
 */
import React from 'react';
import {useTranslation} from 'react-i18next';

import {describeContextForUser} from './feedbackContext';

export const FeedbackContextNotice = ({checked, onChange, context}) => {
    const {t} = useTranslation();
    const rows = describeContextForUser(context, t);

    return (
        <div className="feedback-context">
            <label className="feedback-context__check">
                {/* Checkbox nativo y NO el `Switch` del design system, a propósito: esto es un
                    consentimiento sobre qué datos se envían, no un toggle de configuración, y la
                    convención de formulario es la que corresponde. El `@extend .input-style`
                    global de `_forms.scss` está reseteado en el SCSS de este componente. */}
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(event) => onChange(event.target.checked)}
                />
                <span>
                    <b>{t('feedback.context.label')}</b>
                    <small>{t('feedback.context.sub')}</small>
                </span>
            </label>

            {checked && rows.length > 0 && (
                <details className="feedback-context__details">
                    <summary>{t('feedback.context.details_toggle')}</summary>
                    <dl>
                        {rows.map((row) => (
                            <React.Fragment key={row.label}>
                                <dt>{row.label}</dt>
                                {/* `escapeValue: false` NO es opcional acá: estos valores están
                                    llenos de barras (`/data-explorer`) y sin él i18next las
                                    imprime como `&#x2F;`. Es texto React, no HTML: no hay riesgo
                                    de inyección. */}
                                <dd>{t('feedback.context.raw_value', {
                                    value: row.value, interpolation: {escapeValue: false},
                                })}</dd>
                            </React.Fragment>
                        ))}
                    </dl>
                </details>
            )}
        </div>
    );
};

export default FeedbackContextNotice;
